import React, {useContext, useEffect, useState} from 'react';
import PageIntroSection from "../components/PageIntroSection/PageIntroSection";
import HotelsListItem from "../components/Hotel-list-item/Hotels-list-item";
import {LangContext} from "../App";
import {axios} from "../axios";
import Seo from "../components/Seo/Seo";

const Apartment = () => {
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/apartment`)
            .then(res => setData(res.data.tours))

    },[lang])
    return (
        <div className='hotels-page'>
            <Seo pageKey="apartments" />
            <PageIntroSection/>
            <div className="center-wrapper">
                <div className="hotels-list">
                    {data.map((e,i) => <HotelsListItem path='apartment-page' key={e.id} tour={e} i={i}/> )}
                </div>
            </div>
        </div>
    );
};

export default Apartment;